
import { useState } from "react"
import { postFeedback } from "../../services/ideas.service"
import { CustomTextField } from "../customTextField/customTextField.component"


export const FeedbackDialog = ({ modalType }) => {
    const [type, setType] = useState("")
    const [desc, setDesc] = useState("")
    const [area, setArea] = useState("")
    const [isTypeEmpty, setIsTypeEmpty] = useState(false)
    const [isDescEmpty, setIsDescEmpty] = useState(false)
    const [isAreaEmpty, setIsAreaEmpty] = useState(false)
    const feedbackSubmit = async () => {
        if (!type) {
            return setIsTypeEmpty(true)
        }
        setIsTypeEmpty(false)
        if (type == "bug" || type == "enhancement") {
            if (!area) {
                console.log("this logic working")
                return setIsAreaEmpty(true)
            }
            setIsAreaEmpty(false)
        }
        if (!desc) {
            return setIsDescEmpty(true)
        }
        setIsDescEmpty(false)
        const { status, data } = await postFeedback(type, desc, area)
        if (status == 200) {
            setType("")
            setDesc("")
            setArea("")
            window.location.reload()

        }
    }

    return (
        <>
            <div className="modal fade text-left" id={modalType} aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="myModalLabel1">Submit Feedback</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        <div
                            className="modal-body"
                            style={{ overflowY: "auto", maxHeight: "calc(100vh - 150px)" }}>
                            <h4 className="text-uppercase mb-1">
                                Category
                            </h4>
                            <div className="card">
                                <div className="card-body pa-5">
                                    <select className="form-control" onChange={e => setType(e.target.value)}>
                                        <option value="">SELECT</option>

                                        <option value={"feedback"}>Feedback</option>
                                        <option value={"bug"}>Bug</option>
                                        <option value={"enhancement"}>Enhancement</option>

                                    </select>
                                </div>
                            </div>
                            {isTypeEmpty && <span className="text-danger">Please select category</span>}
                            {(type == "bug" || type == "enhancement") && <>
                                <h4 className="text-uppercase mb-1">
                                    Area
                                </h4>
                                <div className="card">
                                    <div className="card-body pa-5">
                                        <select className="form-control" onChange={e => setArea(e.target.value)}>
                                            <option value="">SELECT</option>
                                            <option value={"User Interface"}>User Interface</option>
                                            <option value={"Feature & Functionality"}>Feature & Functionality</option>

                                        </select>
                                    </div>
                                </div>
                                {isAreaEmpty && <span className="text-danger">Please select area</span>}
                            </>}

                            <CustomTextField fieldName={"Description"} setText={setDesc} />
                            {isDescEmpty && <span className="text-danger">Please enter description</span>}
                        </div>
                        <div className="modal-footer">
                            <div className="text-left" style={{ textAlign: "left" }}>
                                <button className="btn btn-primary" onClick={feedbackSubmit}>Submit</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}